var moment = require("moment-timezone"); moment.tz.add('Africa/Lagos|WAT|-10|0||17e6');